'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { AgoraLogo } from './(guest)/components/Navbar/components';

export default function NotFound() {
  const currentPath = usePathname();

  const handlePath = () => {
    const basePaths = ['/servicios', '/eventos', '/descargables'];

    if (basePaths.some((path) => currentPath.includes(path))) {
      return currentPath.split('/').slice(0, 2).join('/');
    }

    return '/';
  };

  return (
    <div className="relative min-h-screen bg-gradient-to-br from-white via-blue/30 to-red-500/30 flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8">
      <header className="fixed top-0 h-[46px] sm:h-[70px] z-[51] w-full">
        <div className="w-full h-full flex items-center px-4">
          <AgoraLogo onClick={() => (window.location.href = '/')} isWhiteNavbar={false} />
        </div>
      </header>
      <div className="max-w-md w-full space-y-6 text-center py-16">
        <h1 className="text-8xl font-medium text-[#212121]">404</h1>
        <h2 className="mt-4 text-2xl font-medium text-[#212121]">Página no encontrada</h2>
        <p className="mt-2 text-base text-gray-500">
          Lo sentimos, la página que buscas no existe o ha sido movida.
        </p>
        <div className="mt-6">
          <Link href="/">
            <button className="px-6 py-3 bg-blue text-white font-medium rounded-md hover:bg-blue/60 transition-colors duration-200">
              Volver a la página de inicio
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}
